// The tooltip follows a cursor, so touch is ignored: a tap would leave it
// stuck where the finger was, with no hover to end it.
class TooltipTargetElement extends HTMLElement {
  static observedAttributes = ["tooltip"];

  connectedCallback() {
    this.addEventListener("pointerenter", this);
    this.addEventListener("pointerleave", this);
    this._open = false;
  }

  // Changing the text while open updates the tooltip in place.
  attributeChangedCallback() {
    if (this._open) this.start();
  }

  start() {
    this.dispatchEvent(new CustomEvent("tooltip-start", { bubbles: true, detail: { tooltip: this.getAttribute("tooltip") }}));
  }

  disconnectedCallback() {
    if (this._open) {
      this._open = false;
      dispatchEvent(new CustomEvent("tooltip-end", { bubbles: true }));
    }
  }

  handleEvent(e) {
    if (e.pointerType === "touch") return;
    if (e.type === "pointerenter") {
      this._open = true;
      this.start();
    } else if (e.type === "pointerleave" && this._open) {
      this._open = false;
      this.dispatchEvent(new CustomEvent("tooltip-end", { bubbles: true }));
    }
  }
}

customElements.define("tooltip-target", TooltipTargetElement);

class TooltipContainerElement extends HTMLElement {
  connectedCallback() {
    addEventListener("tooltip-start", this);
    addEventListener("tooltip-end", this);
    this._tooltip = this.appendChild(document.createElement("div"));
    this._tooltip.className = "tooltip";
  }

  disconnectedCallback() {
    removeEventListener("tooltip-start", this);
    removeEventListener("tooltip-end", this);
    removeEventListener("mousemove", this);
  }

  handleEvent(e) {
    if (e.type === "tooltip-start") {
      this._tooltip.textContent = e.detail.tooltip;
      addEventListener("mousemove", this);
    } else if (e.type === "tooltip-end") {
      this._tooltip.textContent = "";
      this._tooltip.style.display = null;
      removeEventListener("mousemove", this);
    } else if (e.type === "mousemove") {
      this._tooltip.style.display = "block";
      this._tooltip.style.top = `${e.clientY}px`;
      this._tooltip.style.left = `${e.clientX}px`;
    }
  }
}

customElements.define("tooltip-container", TooltipContainerElement);
